import { ApiCallback } from "./Api";
import { ApiErrors } from "./ApiErrors";



export interface IGeoRequest{
    request?:google.maps.GeocoderRequest;
    search?:string;
    placeId?:string;
    complete:ApiCallback;
    makeNext?:boolean;
}

export default class ApiGoogleMaps{

    private static _geocoderOBJ:{geocoder:google.maps.Geocoder | undefined} = {geocoder:undefined};

    static get geocoder(){
        if(!this._geocoderOBJ.geocoder){
            this._geocoderOBJ.geocoder = new google.maps.Geocoder();
        }
        return this._geocoderOBJ.geocoder;
    }

    _placeService?:google.maps.places.PlacesService;
    _map?:google.maps.Map;


    setupMap=($map:google.maps.Map)=>{
        this._map = $map;
        this._placeService = new google.maps.places.PlacesService($map);

    }
    clearMap=()=>{//cleanup
        this._map = undefined;
        this._placeService = undefined;
    }

    //we can't rapid fire geocodes or google will block us, so we'll make it look like it's loading while we wait
    _apiCooldownPeriod:number=2000;//milliseconds

    _geocodeQueue:IGeoRequest[] = [];
    _isGeocodeTiming:boolean=false;
    _isGeocodeLoading:boolean=false;

    /**
     * 
     * @param $request 
     * @param $complete 
     * @param $makeNext using this will make the rest of the queue not fire a complete
     */
    debouncedGeocode($options:IGeoRequest){

        if($options.makeNext){
            //dumping the queue makes this 1 next
            this._geocodeQueue.length=0;
        }

        this._geocodeQueue.push($options);
        if(!this._isGeocodeTiming && !this._isGeocodeLoading){
            this._processNextGeocode();
        }
    }
    _processNextGeocode=()=>{
        if(this._geocodeQueue.length>0 && !this._isGeocodeTiming && !this._isGeocodeLoading){
            let curQueueItem = this._geocodeQueue.shift();//remove first entry of queue
            if(curQueueItem){
                this._isGeocodeLoading=true;
                this._isGeocodeTiming=true;

                const geoSuccessHandler:ApiCallback=($success,$results)=>{
                    curQueueItem?.complete($success,$results);
                    this._isGeocodeLoading=false;
                    this._processNextGeocode();//tries but needs the other, last wins
                }

                //start load

                if(curQueueItem.placeId){
                    this.getPlace(curQueueItem.placeId,geoSuccessHandler)
                }else if(curQueueItem.request){
                    this.geocode(curQueueItem.request,geoSuccessHandler);
                }else if(curQueueItem.search){
                    //this is not being used anymore... leaving in case we need
                    this.searchPlace(curQueueItem.search,geoSuccessHandler);
                }

                //start timer
                window.setTimeout(()=>{
                    this._isGeocodeTiming=false;
                    this._processNextGeocode();//tries but needs the other, last wins
                },this._apiCooldownPeriod);
            }
        }
    }


    async geocode($request:google.maps.GeocoderRequest, $complete:ApiCallback){
        try{
            console.log("Doing Geocode for ", JSON.stringify($request));

                const geoResponse = await ApiGoogleMaps.geocoder.geocode($request);

                if(geoResponse.results){
                    console.log("Geocoding Success:", geoResponse.results);
                    $complete(true,geoResponse.results);
                }else{
                    console.log("Geocode Fail");
                    $complete(false,ApiErrors.GM_GEOCODE_FAIL);
                }

    

        }catch($error){
            console.log("GEO ERROR", $error);
            
            $complete(false,ApiErrors.GM_GEOCODE_FAIL);
        }
    }
    async getPlace($placeId:string, $complete:ApiCallback){
        try{

            if(this._placeService){
                console.log("Doing Place Lookup for: "+$placeId);
                this._placeService.getDetails({placeId:$placeId},($place,$status)=>{
                    
                    switch($status){
                        case "OK":
                            console.log("Place Lookup Success:", $place);
                            $complete(true,[$place]);
                        break;
                        default://error
                            console.log("A places lookup error occured, using placeId: "+$placeId);
                            $complete(false,ApiErrors.GM_PLACES_ERROR);
                    }
                });
            }else{
                $complete(false,ApiErrors.GM_NO_PLACES_SERVICE);
            }
        }catch($error){
            console.log("PLACE LOOKUP ERROR", $error);
            $complete(false,ApiErrors.GM_PLACES_ERROR);
        }
    }
    async searchPlace($search:string, $complete:ApiCallback){
        try{

            if(this._placeService){
                console.log("Doing Place Search for: "+$search);

                this._placeService.findPlaceFromQuery({query:$search, fields:["name","geometry"]},($results,$status)=>{

                    switch($status){
                        case "OK":
                            $complete(true,$results);
                        break;
                        default://error
                            $complete(false,ApiErrors.GM_SEARCH_ERROR);
                    }
                });
            }else{
                $complete(false,ApiErrors.GM_NO_PLACES_SERVICE);
            }
        }catch($error){
            console.log("PLACE SEARCH ERROR", $error);
            $complete(false,ApiErrors.GM_NO_PLACES_SERVICE);
        }
    }
}